import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "aos/dist/aos.css";
import AOS from "aos";

import HeaderComponent from "../components/common/HeaderComponent";
import FooterComponent from "../components/common/FooterComponent";

import OBAPageIntroComponent from "../components/common/OBAPageIntroComponent";
import ExecutiveCommitteeComponent from "../components/oba/ExecutiveCommitteeComponent";

import logo from "../assests/oba_logo_nbg.png";

import principal from "../assests/exco/principal.webp";
import activePresident from "../assests/exco/active_president.webp";
import jointSecratary1 from "../assests/exco/joint_sec_1.webp";
import jointSecratary2 from "../assests/exco/joint_sec_2.webp";

import assistantSecretary1 from "../assests/exco/assistant_secretary_1.webp";
import assistantSecretary2 from "../assests/exco/assistant_secratary2.png";

import treasurer from "../assests/exco/treasurer.webp";
import assistantTreasure from "../assests/exco/assistant_treasurer.webp";
import chiefOrganizer from "../assests/exco/cheif_organizer.webp";

import vicePresident1 from "../assests/exco/vice_president_1.webp";
import vicePresident2 from "../assests/exco/vice_president_2.webp";
import vicePresident3 from "../assests/exco/vice_president_3.webp";
import vicePresident4 from "../assests/exco/vice_president_4.webp";

import advisor1 from "../assests/exco/advisor_1.webp";
import advisor2 from "../assests/exco/advisor_2.JPG";
import auditor from "../assests/exco/auditor.JPG";

import member01 from "../assests/exco/member_1.webp";
import member2 from "../assests/exco/member_2.webp";
import member4 from "../assests/exco/member_4.webp";
import member5 from "../assests/exco/member_5.webp";
import member6 from "../assests/exco/member6.jpg";
import member9 from "../assests/exco/member9.JPG";
import member10 from "../assests/exco/member10.JPG";
import member11 from "../assests/exco/member11.JPG";
import member12 from "../assests/exco/member12.JPG";
import member13 from "../assests/exco/member13.JPG";
import member16 from "../assests/exco/member16.JPG";
import member17 from "../assests/exco/member17.JPG";
import member17a from "../assests/exco/member17a.png";
import member18 from "../assests/exco/member_18.webp";
import member19 from "../assests/exco/member_19.webp";
import member20 from "../assests/exco/member20.JPG";
import member21 from "../assests/exco/member21.JPG";
import member24 from "../assests/exco/member_24.webp";
import member25 from "../assests/exco/member_25.webp";
import member26 from "../assests/exco/member26.JPG";
import OBAOverviewComponent from "../components/oba/OBAOverviewComponent";
import OBAMissionComponent from "../components/oba/OBAMissionComponent";
import OBAVisionComponent from "../components/oba/OBAVisionComponent";

export default function OldBoysAssociationPage() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.substring(1));
      el?.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  // Executive Committee members
  const committeeMembers = {
    president: [
      {
        name: "Mrs. H G M Jayamali",
        position: "President",
        image: principal,
      },
    ],
    activePresident: [
      {
        name: "Mr. Sampath Duminda De Silva",
        position: "Active President",
        batch: "1994",
        image: activePresident,
      },
    ],
    jointSecretaries: [
      {
        name: "Mr. Dananjaya Jayasundara",
        position: "Joint Secretary",
        batch: "2002",
        image: jointSecratary1,
      },
      {
        name: "Mr. Isuru Lakshitha Amarajeewa",
        position: "Joint Secretary",
        batch: "2003",
        image: jointSecratary2,
      },
    ],
    vicePresidents: [
      {
        name: "Mr. P K M Jagoda",
        position: "Vice President - Special Projects",
        batch: "1980",
        image: vicePresident1,
      },
      {
        name: "Mr. G P Panduka Nuwan",
        position: "Vice President - Special Projects",
        batch: "1998",
        image: vicePresident2,
      },
      {
        name: "Mr. G G Milinda Chandrasena",
        position: "Vice President - Sports Development",
        batch: "2000",
        image: vicePresident3,
      },
      {
        name: "Mr. Suresh Sumeda De silva",
        position: "Vice President - Education Development",
        batch: "2002",
        image: vicePresident4,
      },
    ],
    deputySecretaries: [
      {
        name: "Mr. K G Kamila Nishantha",
        position: "Assistant Secretary",
        batch: "2005",
        image: assistantSecretary1,
      },
      {
        name: "Mr. Namal Eeshan",
        position: "Assistant Secretary",
        batch: "2010",
        image: assistantSecretary2,
      },
    ],
    treasurer: [
      {
        name: "Mr. Chandima Lakmal",
        position: "Treasurer",
        batch: "2005",
        image: treasurer,
      },
    ],
    assistantTreasurer: [
      {
        name: "Mr. Dhanesh Kumara Dias Nagahawatta",
        position: "Assistant Treasurer",
        batch: "1999",
        image: assistantTreasure,
      },
    ],
    committeeMembers: [
      {
        name: "Mr. D A D Fernando",
        position: "Committee Member",
        batch: "1989",
        image: member01,
      },
      {
        name: "Mr. P G Gunarathna",
        position: "Committee Member",
        batch: "1989",
        image: member2,
      },
      {
        name: "Mr. U G Milan Thakshila",
        position: "Committee Member",
        batch: "1996",
        image: member4,
      },
      {
        name: "Mr. Pramod Ranga",
        position: "Committee Member",
        batch: "1996",
        image: member5,
      },
      {
        name: "Mr. Thusitha Janaka Liyanage",
        position: "Committee Member",
        batch: "2000",
        image: member6,
      },
      {
        name: "Mr. Manju Sri Prasanna",
        position: "Committee Member",
        batch: "2004",
        image: member11,
      },
      {
        name: "Mr. M G Janaka Manoj Dilruwan",
        position: "Committee Member",
        batch: "2006",
        image: member12,
      },
      {
        name: "Mr. Thushitha Deshapriya",
        position: "Committee Member",
        batch: "2007",
        image: member13,
      },
      {
        name: "Mr. T H Tharindu Ushan Madusanka",
        position: "Committee Member",
        batch: "2011",
        image: member9,
      },
      {
        name: "Mr. U D Nimesh Naushalya Gunarathna",
        position: "Committee Member",
        batch: "2011",
        image: member10,
      },
      {
        name: "Mr. Sanka Dayananda",
        position: "Committee Member",
        batch: "2011",
        image: member16,
      },
      {
        name: "Mr. Mohomed Muadh",
        position: "Committee Member",
        batch: "2011",
        image: member17a,
      },
      {
        name: "Mr. N P Ramesh Hasanka",
        position: "Committee Member",
        batch: "2013",
        image: member17,
      },
      {
        name: "Mr. Shashika Ovin",
        position: "Committee Member",
        batch: "2013",
        image: member18,
      },
      {
        name: "Mr. Dasun Tharaka",
        position: "Committee Member",
        batch: "2013",
        image: member19,
      },
      {
        name: "Mr. M K Nimantha Jayanaka",
        position: "Committee Member",
        batch: "2014",
        image: member20,
      },
      {
        name: "Mr. Hashan Sanjayalal Sarukkali",
        position: "Committee Member",
        batch: "2014",
        image: member21,
      },
      {
        name: "Mr. Buddika Shehan Sandeepa",
        position: "Committee Member",
        batch: "2018",
        image: member24,
      },
      {
        name: "Mr. K Lakshan Madushanka",
        position: "Committee Member",
        batch: "2018",
        image: member26,
      },
      {
        name: "Mr. Nomin Yasanjith",
        position: "Committee Member",
        batch: "2022",
        image: member25,
      },
    ],
    organizer: [
      {
        name: "Mr. Duminda Ariyarathna",
        position: "Chief Organizer",
        batch: "2003",
        image: chiefOrganizer,
      },
    ],
    advisor: [
      {
        name: "Mr. Rathnasiri Manamperi",
        position: "Advisor",
        batch: "1980",
        image: advisor1,
        note: "Non-Voting",
      },
      {
        name: "Mr. Dinesh Manawadu",
        position: "Advisor",
        batch: "1996",
        image: advisor2,
        note: "Non-Voting",
      },
    ],
    auditor: [
      {
        name: "Mr. Thushan Madushanka",
        position: "Auditor",
        batch: "2005",
        image: auditor,
        note: "Non-Voting",
      },
    ],
  };

  const executiveCommittee = {
    name: "Executive Committee - 2025/26",
    committeeMembers: committeeMembers,
  };

  return (
    <div className="d-flex flex-column min-vh-100 overflow-x-hidden">
      <HeaderComponent user={null} />
      {/* <NavigationPanelComponent /> */}

      <main className="flex-grow-1 py-5" style={{ backgroundColor: "#f8f9fa" }}>
        <div className="container px-3">
          {/* Hero Section */}
          <OBAPageIntroComponent
            image={logo}
            title="Old Boys' Association of Vidyaloka College"
            description="Connecting past, present, and future generations of Vidyalokians.
              Our association fosters a strong community among former students
              and actively supports the development of Vidyaloka College in
              Galle, Sri Lanka."
          />

          {/* OBA Description Section*/}
          <OBAOverviewComponent />
          <OBAMissionComponent />
          <OBAVisionComponent />

          {/* Executive Committee Section */}
          <ExecutiveCommitteeComponent
            executiveCommittee={executiveCommittee}
          />
        </div>
      </main>

      <FooterComponent />
    </div>
  );
}
